import { render, staticRenderFns } from "./PreExistingAccreditation.vue?vue&type=template&id=4babb084&"
import script from "./PreExistingAccreditation.vue?vue&type=script&lang=js&"
export * from "./PreExistingAccreditation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports